/* sv-consent-attrs (AN-26, 2026-10-01): stan zgody i identyfikatory reklamowe w ukrytych atrybutach koszyka (prefiks _ = niewidoczne
   dla klientki, widoczne w zamówieniu w Admin API). Czyta je kolektor AN-10 (zakupy z serwera do Google Ads).
   - zgoda tylko z Shopify Customer Privacy API (to samo źródło, z którego korzystają piksele Shopify); bez zgody nic nie zapisujemy
     i nic nie trzymamy w przeglądarce;
   - zgoda analityczna: _sv_consent, _ga_cid (z _ga), _ga_sid (z _ga_FKYK3H94J2);
   - zgoda marketingowa: dodatkowo _gclid / _gbraid / _wbraid (adres wejścia, potem ciasteczka _gcl_aw / _gcl_gb) i _sv_sa
     (session_attributes wg skryptu Google: support.google.com/google-ads/answer/16194756);
   - jeden POST /cart/update.js tylko przy niepustym koszyku (B-13: nie zakładamy koszyka gościom), w bezczynności przeglądarki,
     tylko gdy treść różni się od ostatnio zapisanej w tym koszyku (pamięć w sessionStorage, zakładana dopiero po zgodzie);
   - wycofanie zgody (visitorConsentCollected) = te same klucze z pustą wartością, tylko gdy w koszyku są nasze wartości.
   Nie ruszamy innych atrybutów: /cart/update.js łączy podane klucze z istniejącymi. */
(function () {
  if (window.svConsentAttrs) return;
  var GA4_STREAM = 'FKYK3H94J2';
  var KEYS = ['_sv_consent', '_ga_cid', '_ga_sid', '_gclid', '_gbraid', '_wbraid', '_sv_sa'];
  var SS_IDS = 'sv_an26_ids', SS_SENT = 'sv_an26_sent';
  var landing = readLanding();
  var timer = null, busy = false, again = false;

  function ss(op, k, v) {
    try {
      if (op === 'get') return window.sessionStorage.getItem(k);
      if (op === 'set') window.sessionStorage.setItem(k, v);
      else window.sessionStorage.removeItem(k);
    } catch (e) {}
    return null;
  }
  function cookie(name) {
    try {
      var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : '';
    } catch (e) { return ''; }
  }
  /* identyfikatory z adresu wejścia: tylko w pamięci strony, do sessionStorage dopiero przy zgodzie marketingowej */
  function readLanding() {
    var out = null;
    try {
      var q = new URLSearchParams(window.location.search);
      var hasGad = false;
      q.forEach(function (v, k) { if (k.indexOf('gad_') === 0) hasGad = true; });
      if (!hasGad && !q.has('gclid') && !q.has('gbraid') && !q.has('wbraid')) return null;
      out = { gclid: q.get('gclid') || '', gbraid: q.get('gbraid') || '', wbraid: q.get('wbraid') || '', sa: '' };
      var p = {};
      q.forEach(function (v, k) { if (k.indexOf('gad_') === 0) p[k] = v; });
      p.session_start_time_usec = (Date.now() * 1000).toString();
      p.landing_page_url = window.location.href;
      p.landing_page_referrer = document.referrer;
      p.landing_page_user_agent = navigator.userAgent;
      try { out.sa = btoa(JSON.stringify(p)); } catch (e) { out.sa = ''; }
    } catch (e) {}
    return out;
  }
  function api() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    return cp && typeof cp.analyticsProcessingAllowed === 'function' ? cp : null;
  }
  function consent() {
    var cp = api();
    if (!cp) return null;
    var a = false, m = false;
    try { a = !!cp.analyticsProcessingAllowed(); } catch (e) {}
    try { m = !!cp.marketingAllowed(); } catch (e) {}
    return { a: a, m: m };
  }
  function gaClientId() {
    var parts = cookie('_ga').split('.');
    return parts.length >= 4 ? parts.slice(-2).join('.') : '';
  }
  function gaSessionId() {
    var v = cookie('_ga_' + GA4_STREAM);
    if (!v) return '';
    var gs2 = v.match(/^GS2\.\d+\.s(\d+)/);
    if (gs2) return gs2[1];
    var parts = v.split('.');
    return parts.length > 2 && /^\d+$/.test(parts[2]) ? parts[2] : '';
  }
  function gclCookie(name) {
    var parts = cookie(name).split('.');
    return parts.length >= 3 ? parts.slice(2).join('.') : '';
  }
  function payload(c) {
    var p = {};
    KEYS.forEach(function (k) { p[k] = ''; });
    if (!c || (!c.a && !c.m)) return p;
    p._sv_consent = 'a' + (c.a ? 1 : 0) + 'm' + (c.m ? 1 : 0);
    if (c.a) {
      p._ga_cid = gaClientId();
      p._ga_sid = gaSessionId();
    }
    if (c.m) {
      var ids = landing;
      if (!ids) { try { ids = JSON.parse(ss('get', SS_IDS) || 'null'); } catch (e) { ids = null; } }
      ids = ids || {};
      p._gclid = ids.gclid || gclCookie('_gcl_aw');
      p._gbraid = ids.gbraid || gclCookie('_gcl_gb');
      p._wbraid = ids.wbraid || '';
      p._sv_sa = ids.sa || '';
    }
    return p;
  }
  function cartCount() {
    var st = document.querySelector('script[data-sv-gw-state]');
    if (st) { try { return JSON.parse(st.textContent).count || 0; } catch (e) {} }
    var b = document.querySelector('.cart-count-bubble span[aria-hidden]');
    return b ? parseInt(b.textContent, 10) || 0 : 0;
  }
  function cartToken() { return cookie('cart').split('?')[0]; }

  /* opts.withdraw: zgoda cofnięta w tej odsłonie (odczyt /cart.js i puste wartości, jeśli w koszyku są nasze klucze)
     opts.nonEmpty: wiadomo z cartUpdate, że koszyk ma pozycje
     opts.force: tylko do testu (zapis także przy pustym koszyku) */
  function sync(opts) {
    opts = opts || {};
    if (busy) { again = true; return Promise.resolve('busy'); }
    var c = consent();
    if (!c) return Promise.resolve('no-api');
    var allowed = c.a || c.m;
    if (!allowed && !opts.withdraw) return Promise.resolve('no-consent');
    if (c.m && landing) ss('set', SS_IDS, JSON.stringify(landing));
    if (!c.m) ss('remove', SS_IDS);
    if (!opts.force && !opts.withdraw && !opts.nonEmpty && cartCount() < 1) return Promise.resolve('empty-cart');
    var p = payload(c);
    var sig = cartToken() + '|' + JSON.stringify(p);
    if (allowed && ss('get', SS_SENT) === sig) return Promise.resolve('same');
    busy = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    /* cofnięcie zgody: czyścimy tylko wtedy, gdy w koszyku są nasze wartości (jeden odczyt /cart.js, tylko przy tym zdarzeniu) */
    var check = allowed ? Promise.resolve(true) : fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var at = (cart && cart.attributes) || {};
        return KEYS.some(function (k) { return !!at[k]; });
      });
    return check.then(function (need) {
      if (!need) return 'nothing-to-clear';
      return post(root, p, allowed);
    }).catch(function () { return 'error'; }).then(function (res) {
      busy = false;
      if (again) { again = false; schedule(opts); }
      return res;
    });
  }
  function post(root, p, allowed) {
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: p })
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      if (allowed) ss('set', SS_SENT, cartToken() + '|' + JSON.stringify(p));
      else { ss('remove', SS_SENT); ss('remove', SS_IDS); }
      return allowed ? 'written' : 'cleared';
    });
  }
  function schedule(opts) {
    clearTimeout(timer);
    timer = setTimeout(function () {
      if ('requestIdleCallback' in window) window.requestIdleCallback(function () { sync(opts); }, { timeout: 4000 });
      else sync(opts);
    }, 1500);
  }
  function withApi(cb) {
    if (api()) return cb();
    try {
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (!err) cb(); });
      }
    } catch (e) {}
  }

  window.svConsentAttrs = { sync: sync, payload: function () { return payload(consent()); } };

  document.addEventListener('visitorConsentCollected', function (e) {
    var d = (e && e.detail) || {};
    schedule({ withdraw: !d.analyticsAllowed && !d.marketingAllowed });
  });
  function start() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
        var data = ev && ev.cartData;
        var empty = data && typeof data.item_count === 'number' && data.item_count === 0;
        if (!empty) schedule({ nonEmpty: true });
      });
    }
    withApi(function () { schedule({}); });
  }
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start, { once: true });
})();
